module.exports = __webpack_public_path__ + "img/home_img_earth_right.b62caede.png";